module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M24.344 6.504c.996-.514 1.104-.362.244.34L7.117 21.161c-.762.55-1.226 1.62-1.226 2.514v7.282c0 1.08.566 1.368 1.41.646l7.104-6.152 5.138 4.824c.404.376.876.272 1.074-.234L31.944.633c.198-.506-.078-.762-.608-.57L.476 11.206c-.532.19-.634.65-.228 1.03L4.12 15.87c.402.376 1.132.476 1.628.218l18.595-9.585z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/send-1.js
// module id = 1401
// module chunks = 14